import { Injectable } from '@angular/core';
import { OfficerDetailFacade } from '@intrensic/shared/officer-details';
import { BaseApiService } from '@shared/data-access';
import { AgencyDetailsFacade } from '@shared/feature/agency-details';
import { UploadImageService } from '@shared/feature/upload-file';
import { AppConfig } from '@shared/utils/app-config';
import { UserRole } from '@shared/utils/base-auth';
import { Observable, first, map, of, switchMap } from 'rxjs';
import { TranslationFromJsonService } from '@shared/feature/translate';

@Injectable({
  providedIn: 'root',
})
export class IntrensicAgencyUploadImageService extends UploadImageService {
  constructor(
    api: BaseApiService,
    private officerDetailsFacade: OfficerDetailFacade,
    private agencyFacade: AgencyDetailsFacade,
    private appConfig: AppConfig,
    private translationFromJsonService: TranslationFromJsonService
  ) {
    super(api);
  }

  override isLoading(): Observable<boolean> {
    return this.agencyFacade.isImageLoading();
  }

  override uploadDone(): Observable<boolean> {
    return of(true);
  }

  override getImage(): Observable<string> {
    return this.agencyFacade.getAgencyPhoto().pipe(map((x) => x ?? this.appConfig.statics.blueLogo));
  }

  override uploadImage(image: File): void {
    this.officerDetailsFacade
      .getLoggedInOfficer()
      .pipe(
        first(),
        switchMap((officer) => {
          const role = officer.role;
          if (role === UserRole.HRAdmin || role === UserRole.SuperAdmin) {
            this.agencyFacade.updateAgencyPhoto(image);
          }

          return '';
        })
      )
      .subscribe();
  }

  override uploadImageApi(image: File): Observable<string> {
    const form = new FormData();
    form.append('file', image);

    return this.api.postFormData('api/customers/picture', form).pipe(map((url) => `${url}?t=${Date.now()}`));
  }

  override getTitle(): string {
    return this.translationFromJsonService.instant('upload-image-customer-title');
  }
}
